export const EVALUATION_RESULTS = {
    CORRECT: "correct",
    INCORRECT: "incorrect",
    PARTIALLY_CORRECT: "partially_correct"
  } as const;

  export type EvaluationResult = "correct" | "incorrect" | "partially_correct";

  export const EVALUATION_RESULT_LABELS = {
    [EVALUATION_RESULTS.CORRECT]: "Correct",
    [EVALUATION_RESULTS.INCORRECT]: "Incorrect", 
    [EVALUATION_RESULTS.PARTIALLY_CORRECT]: "Partially Correct"
  } as const;
  
  export const EVALUATION_RESULT_OPTIONS = [
    { value: EVALUATION_RESULTS.CORRECT, label: EVALUATION_RESULT_LABELS[EVALUATION_RESULTS.CORRECT] },
    { value: EVALUATION_RESULTS.INCORRECT, label: EVALUATION_RESULT_LABELS[EVALUATION_RESULTS.INCORRECT] },
    { value: EVALUATION_RESULTS.PARTIALLY_CORRECT, label: EVALUATION_RESULT_LABELS[EVALUATION_RESULTS.PARTIALLY_CORRECT] }
  ];

  export const ATTEMPT_STATUS={
    ATTEMPTED:"attempted",
    UNATTEMPTED:"unattempted"
} as const;

  export type AttemptStatus = "attempted" | "unattempted";

  export const ATTEMPT_STATUS_LABELS = {
    [ATTEMPT_STATUS.ATTEMPTED]:"Attempted",
    [ATTEMPT_STATUS.UNATTEMPTED]:"Unattempted"
} as const;

export const ATTEMPT_STATUS_OPTIONS = [
  { value: ATTEMPT_STATUS.ATTEMPTED, label: ATTEMPT_STATUS_LABELS[ATTEMPT_STATUS.ATTEMPTED] },
  { value: ATTEMPT_STATUS.UNATTEMPTED, label: ATTEMPT_STATUS_LABELS[ATTEMPT_STATUS.UNATTEMPTED] }
];

/** Used by L1 report summary for attempted / unattempted checks */
export const EVALUATION_VERDICTS = {
  UNATTEMPTED: ATTEMPT_STATUS.UNATTEMPTED,
  ATTEMPTED: ATTEMPT_STATUS.ATTEMPTED,
} as const;

export const REPORT_ERROR_REASONS = {
  IMAGE_SCAN_QUALITY_POOR: "image_scan_quality_poor",
  PAPER_CROPPED: "paper_partially_cut",
  PAPER_ROTATED_OR_MISALIGNED: "paper_rotated_misaligned",
  WRONG_PAPER_SUBMITTED: "wrong_paper_submitted",
  OTHER: "other",
} as const;

export type ReportErrorReason =
  (typeof REPORT_ERROR_REASONS)[keyof typeof REPORT_ERROR_REASONS];

export const REPORT_ERROR_REASON_LABELS = {
  [REPORT_ERROR_REASONS.IMAGE_SCAN_QUALITY_POOR]:
    "Image/scan quality is poor or blurry",
  [REPORT_ERROR_REASONS.PAPER_CROPPED]:
    "Paper is partially cut or cropped",
  [REPORT_ERROR_REASONS.PAPER_ROTATED_OR_MISALIGNED]:
    "Paper is rotated or misaligned",
  [REPORT_ERROR_REASONS.WRONG_PAPER_SUBMITTED]: "Wrong paper is submitted",
  [REPORT_ERROR_REASONS.OTHER]: "Other",
} as const;

export const REPORT_ERROR_REASON_OPTIONS = [
  {
    value: REPORT_ERROR_REASONS.IMAGE_SCAN_QUALITY_POOR,
    label:
      REPORT_ERROR_REASON_LABELS[REPORT_ERROR_REASONS.IMAGE_SCAN_QUALITY_POOR],
  },
  {
    value: REPORT_ERROR_REASONS.PAPER_CROPPED,
    label: REPORT_ERROR_REASON_LABELS[REPORT_ERROR_REASONS.PAPER_CROPPED],
  },
  {
    value: REPORT_ERROR_REASONS.PAPER_ROTATED_OR_MISALIGNED,
    label:
      REPORT_ERROR_REASON_LABELS[
        REPORT_ERROR_REASONS.PAPER_ROTATED_OR_MISALIGNED
      ],
  },
  {
    value: REPORT_ERROR_REASONS.WRONG_PAPER_SUBMITTED,
    label:
      REPORT_ERROR_REASON_LABELS[REPORT_ERROR_REASONS.WRONG_PAPER_SUBMITTED],
  },
  {
    value: REPORT_ERROR_REASONS.OTHER,
    label: REPORT_ERROR_REASON_LABELS[REPORT_ERROR_REASONS.OTHER],
  },
];

/** localStorage key for skipping the single-question proceed confirmation modal */
export const HIDE_SINGLE_QUESTION_CONFIRMATION_KEY =
  "hideSingleQuestionConfirmation";

export const FOOTER_VIEW_MODE = {
  REPORT: "report",
  SINGLE_QUESTION: "singleQuestion",
  MULTI_QUESTION: "multiQuestion",
} as const;

export type FooterViewMode =
  (typeof FOOTER_VIEW_MODE)[keyof typeof FOOTER_VIEW_MODE];